import { Dispatch, SetStateAction, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { NotificationRule } from 'ais-facade-api/api';
import { Button, Dropdown, DropDownItem } from 'app/components';
import { setSelectedNtfRules } from 'app/utils/tableSlice';
import { useAppDispatch } from 'app/store/store';

import styles from './NtfRuleActionCell.module.scss';
interface NtfRuleActionCellI {
  deleteNtfRuleModalState: [boolean, Dispatch<SetStateAction<boolean>>];
  rule: NotificationRule;
}

export const NtfRuleActionCell = ({ rule, deleteNtfRuleModalState }: NtfRuleActionCellI) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const [dropdown, setDropdown] = useState(false);
  const [, setShowDeleteModal] = deleteNtfRuleModalState;

  const deleteModalToggle = () => {
    setShowDeleteModal(true);
    dispatch(setSelectedNtfRules([rule.key]));
  };


  return (
    <>
      <Button
        variant='icon-only'
        iconName='more-icon'
        iconSize="13px"
        className={styles.icon_button}
        aria-expanded={dropdown ? 'true' : 'false'}
        onClick={() => setDropdown((prev) => !prev)}
      />

      <Dropdown
        dropdown={dropdown}
        onClickOutside={() => {
          setDropdown(false);
        }}
      >
        <DropDownItem>
          <Button
            label={t('ButtonLabelDelete')}
            onClick={deleteModalToggle}
            type='button'
          />
        </DropDownItem>
      </Dropdown>
    </>
  );
};
